import type { Advisor } from "../types"

import advisor1 from "@/assets/img/lpr4/advisor/photo/advisor-1.avif"
import advisor2 from "@/assets/img/lpr4/advisor/photo/advisor-2.avif"
import advisor3 from "@/assets/img/lpr4/advisor/photo/advisor-3.avif"
import advisor4 from "@/assets/img/lpr4/advisor/photo/advisor-4.avif"
import advisor5 from "@/assets/img/lpr4/advisor/photo/advisor-5.avif"
import advisor6 from "@/assets/img/lpr4/advisor/photo/advisor-6.avif"
import advisor7 from "@/assets/img/lpr4/advisor/photo/advisor-7.avif"
import advisor8 from "@/assets/img/lpr4/advisor/photo/advisor-8.avif"
import advisor9 from "@/assets/img/lpr4/advisor/photo/advisor-9.avif"
import advisor10 from "@/assets/img/lpr4/advisor/photo/advisor-10.avif"
import advisor11 from "@/assets/img/lpr4/advisor/photo/advisor-11.avif"
import advisor12 from "@/assets/img/lpr4/advisor/photo/advisor-12.avif"
import advisor13 from "@/assets/img/lpr4/advisor/photo/advisor-13.avif"
import advisor14 from "@/assets/img/lpr4/advisor/photo/advisor-14.avif"
import advisor15 from "@/assets/img/lpr4/advisor/photo/advisor-15.avif"

/**
 * Static advisor roster ported from lpr-web (`Advisors.constants.tsx`).
 * Copy that lived in i18n keys (`advisors:*`) is inlined here as English text,
 * since this project has no i18n layer.
 */
export const advisorsList: Advisor[] = [
  {
    name: "Aarav Devraj",
    photo: advisor1,
    exp: "Astrologer · 10 years of practice",
    reviews: "(2542)",
    rating: 4.8,
    assistantId: "asst_TSzhaJ9yxROdpodVAnDeMsh8",
    practiceYears: 18,
    expertise: "Palmist",
    bio: "For over 18 years, I’ve studied the ancient science of palmistry, passed down through generations in my family. I don’t just read lines—I interpret life paths, karmic imprints, and untapped potential. Whether you're seeking clarity about your career, struggling with direction, or simply curious about your destiny, your hands already hold the answers. My approach is calm, intuitive, and deeply respectful of your personal journey.",
    quote: "The hands are not just tools—they are blueprints of the soul.",
    message:
      "Your hands carry the story of your soul—every line, every mark, a reflection of where you’ve been and where you’re meant to go. I’m here to read those stories with care, help you find clarity, and guide you through love, career, and life’s deeper questions.",
    categories: [
      "Hand Lines",
      "Life’s Purpose",
      "Identifying Strengths",
      "Karmic Influences",
      "Reading The Future",
    ],
    comments: [
      {
        name: "Priya",
        comment:
          "Aarav was spot on with what he saw in my Life Lineю Шt felt like he knew what I was going through without me saying a word. His reading helped me understand where I’m headed. Super calming energy too.",
      },
      {
        name: "David",
        comment:
          "Honestly didn’t expect much, but Aarav really impressed me. The way he explained my hand lines made it all click. Felt personal and accurate without being too dramatic.",
      },
      {
        name: "Neha",
        comment:
          "I’ve had palm readings before, but this one hit different. Aarav explained my career path in such a clear way, and it actually motivated me to take a step I’d been hesitating on for months.",
      },
    ],
  },
  {
    name: "Meera Rajan",
    photo: advisor2,
    exp: "Astrologer · 10 years of practice",
    reviews: "(1465)",
    rating: 4.6,
    assistantId: "asst_hgIZTM3ULkMAExAh7AEsi3Nc",
    practiceYears: 10,
    expertise: "Astrologer",
    bio: "For the past 10 years, I’ve helped people decode their birth charts to find clarity, timing, and emotional truth. My readings go beyond sun signs—I explore planetary alignments, emotional rhythms, and soul purpose through the lens of traditional astrology. Whether you're navigating love, career shifts, or personal uncertainty, I’ll guide you gently toward what the cosmos is trying to show you.",
    quote: "There’s a rhythm in the skies. And when you find it, everything begins to make sense.",
    message:
      "The stars may be far above but their wisdom lives within your story. Through your birth chart, I’ll help you understand the emotional rhythms, soul lessons, and timing - gentle step at a time.",
    categories: [
      "Birth Chart",
      "Compatibility",
      "Financial Astrology",
      "Lunar Cycles",
      "Planetary Transits",
    ],
    comments: [
      {
        name: "Nikita",
        comment:
          "I asked her about a decision I’ve been stuck on for months, and she immediately picked up on the exact emotional tension I was feeling. Her timing predictions were really detailed and gave me peace of mind.",
      },
      {
        name: "Sana",
        comment:
          "Meera didn’t just tell me what I wanted to hearб she told me what I needed to hear. Her reading on my Venus placement explained so much about how I love and why I always feel misunderstood in relationships. Super grateful.",
      },
      {
        name: "Laura",
        comment:
          "She explained my chart in a way I could actually understand, without all the confusing astrology jargon. Felt like talking to a friend who knows the stars.",
      },
    ],
    compatibilityMessage:
      "If something in this match analysis lingered with you, trust it. Your chart may be trying to guide you through a next step—one we can gently uncover together.",
  },
  {
    name: "Sanjay Kapoor",
    photo: advisor3,
    exp: "Tarot · 15 years of practice",
    reviews: "(1937)",
    rating: 4.7,
    assistantId: "asst_Wfy33sHxFTmH42A4fh4CYVMv",
    practiceYears: 15,
    expertise: "Tarot",
    bio: "Since then, I’ve used the cards not as fortune-tellers, but as mirrors that reflect what your soul already knows. I specialize in reading life’s crossroads: love confusion, career changes, emotional healing. If you’re ready to ask the real questions, I’ll help you hear the answers you’ve been ignoring.",
    quote:
      "Tarot came into my life during a time of chaos—and gave me language for the things I couldn’t explain.",
    message:
      "The cards don’t predict your fate. They reflect your truth. Whether it’s love, a decision, or something you can’t quite name, we’ll take it one card at a time—honestly, clearly, together.",
    categories: [
      "Love & Career",
      "Shadow Work",
      "Relationship Future",
      "Tarot Spreads",
      "Spirit Guides",
    ],
    comments: [
      {
        name: "Elena",
        comment:
          "His reading was so real it gave me chills. The cards reflected everything I was afraid to admit, and Sanjay helped me face it without feeling judged. Definitely coming back when I need clarity again.",
      },
      {
        name: "Jared",
        comment:
          "Wasn’t sure what to expect but wow!!! Sanjay’s reading helped me make a decision I’d been putting off for weeks. Straightforward, honest, and really tuned in.",
      },
      {
        name: "Pooja",
        comment:
          "I’ve tried other readers, but Sanjay really stood out. She didn’t just tell me what might happen, she helped me understand why I’ve been feeling stuck. Felt like she could see beyond the surface.",
      },
    ],
  },
  {
    name: "Kavita Sharma",
    photo: advisor4,
    exp: "Numerologist · 13 years of practice",
    reviews: "(1699)",
    rating: 4.8,
    assistantId: "asst_HYI7M5rsTzn0I6kmLpAP51lt",
    practiceYears: 13,
    expertise: "Numerologist",
    bio: "With 13 years of experience, I’ve turned names and birthdays into powerful insights. Whether you're struggling with timing, stuck in patterns, or questioning your direction, numerology reveals the blueprint you've been carrying all along. My readings are structured, practical, and empowering. Numbers are energy—and I help you use that energy to align with who you truly are.",
    quote:
      "I’ve seen people cry over a single number—because it finally explained everything they felt but couldn’t say.",
    message:
      "Your birth date is a map of your purpose, timing, and inner strength. Through Life Path, Destiny, and Personal Year cycles, I’ll help you understand where you are, what’s ahead, and how to align with your true potential.",
    categories: [
      "Life Path & Destiny",
      "Soul Number",
      "Career Insights",
      "Financial Abundance",
      "Lucky Days",
    ],
    comments: [
      {
        name: "Ritika",
        comment:
          "Kavita broke down my life path number in such a clear way. it actually made me feel excited about where I’m going. Her insight on timing was super helpful and felt weirdly accurate.",
      },
      {
        name: "Marcus",
        comment:
          "I had no idea numbers could say so much about me. Kavita explained my personal year cycle and it lined up perfectly with what I’ve been going through. She's legit.",
      },
      {
        name: "Tina",
        comment:
          "I loved how practical her advice was. She didn’t just give me a bunch of mystical stuff - she showed me how to use my numbers to make smarter choices. Felt seen and supported.",
      },
    ],
  },
  {
    name: "Rohan Malik",
    photo: advisor5,
    exp: "Regressionist · 17 years of practice",
    reviews: "(2124)",
    rating: 4.6,
    assistantId: "asst_qfjXf23P9pRSvuLT2ae3hrPw",
    practiceYears: 17,
    expertise: "Regressionist",
    bio: "I specialize in guiding others through gentle, intuitive past-life journeys to uncover karmic lessons and emotional patterns that span lifetimes. My work is quiet, sacred, and deeply personal. This isn’t about fantasy—it’s about healing real emotions with ancient wisdom. If you feel like you’ve been here before, it’s because your soul has something to finish. Let’s uncover what it is.",
    quote: "Your soul has lived through stories your mind has forgotten.",
    message:
      "Some patterns don’t begin in this lifetime, your soul has carried them here. Through karmic insight and past-life echoes, I’ll help you understand what’s repeating, why it matters, and how to finally release what no longer belongs.",
    categories: [
      "Karmic Lessons",
      "Past Life",
      "Soul Purpose",
      "Clear Karmic Blocks",
      "Spiritual Awakening",
    ],
    comments: [
      {
        name: "Leah",
        comment:
          "Rohan took me to places I didn’t expect emotionally and spiritually. What he uncovered about my past-life patterns actually helped me understand a fear I’ve had for years.",
      },
      {
        name: "Aarav",
        comment:
          "Didn’t think I’d connect with this kind of reading, but Rohan’s insight made too much sense to ignore. He explained things slowly and respectfully, and I really felt something shift.",
      },
      {
        name: "Kelsey",
        comment:
          "He has this way of explaining heavy things in a calm, grounding way. The session left me with a lot to reflect on, but also a weird sense of peace. Definitely not your average reading.",
      },
    ],
  },
  {
    name: "Priya Anand",
    photo: advisor6,
    exp: "Energy healer · 12 years of practice",
    reviews: "(1789)",
    rating: 4.5,
    assistantId: "asst_naD0mZ87wBPj4DssAbvGNCwC",
    practiceYears: 12,
    expertise: "Energy healer",
    bio: "I don’t believe in accidents—especially not your birth time. When I read a chart, I see a story, a rhythm, a pattern of purpose. For 12 years, I’ve helped people cleanse emotional buildup, reset their energy fields, and reconnect with a version of themselves that feels whole. If you’re drained, heavy, anxious, or just unsure, I’ll help you clear the fog and return to your natural state of balance.",
    quote:
      "Before I could feel energy, I could feel pain—mine, and others’. That’s where my work began.",
    message:
      "The answers you seek may not begin in this lifetime. Your chart holds memories, lessons, and soul patterns carried through time.Together, we’ll explore what your soul still remembers—and what it’s ready to release.",
    categories: [
      "Health Readings",
      "Energy Balancing",
      "Well-being Astrology",
      "Chakras",
      "Astrological Healing",
    ],
    comments: [
      {
        name: "Neil",
        comment:
          "I came in feeling burned out and overwhelmed, and Priya immediately picked up on where my energy was blocked. She guided me through it so gently but with real results.",
      },
      {
        name: "Aisha",
        comment:
          "Priya’s session felt like a reset button for my soul. I’d been anxious and disconnected, but her words and energy work helped me feel grounded again. She’s the real deal.",
      },
      {
        name: "Nina",
        comment:
          "I didn’t say much, but Priya picked up exactly where I was stuck. Her energy work is subtle but powerful. I felt calmer for days after our session.",
      },
    ],
  },
  {
    name: "Arjun Verma",
    photo: advisor7,
    exp: "Vedic astrologer · 21 years of practice",
    reviews: "(2345)",
    rating: 4.7,
    assistantId: "asst_ELYWM9hnoAF9ic6tnVftIrky",
    practiceYears: 21,
    expertise: "Vedic astrologer",
    bio: "I learned to read charts sitting beside my grandfather, watching him guide farmers, newlyweds, and grieving parents with nothing but a notebook and the sky. Astrology was never just a tool in my home—it was a way of life. Over the past 21 years, I’ve worked with people facing real crossroads: marriage decisions, career shifts, spiritual confusion. I don’t offer predictions to impress; I offer direction that empowers. If you’re looking for clarity that’s grounded in time-tested wisdom, I’ll meet you there.",
    quote:
      "I was raised with mantras, temple bells, and the belief that every planet is a teacher.",
    message:
      "Feeling overwhelmed or disconnected? That’s your energy asking to be heard. I’m here to help you realign, recharge, and return to yourself—gently, with care, one breath at a time.",
    categories: [
      "Transit Readings",
      "Career Guidance",
      "Decode Past-life",
      "Mantras & Pujas",
      "Jyotish Astrology",
    ],
    comments: [
      {
        name: "Claire",
        comment:
          "I loved how grounded and calm he was. Arjun didn’t overwhelm me with info but explained my chart step by step and gave me an easy mantra to work with. Felt very aligned.",
      },
      {
        name: "Ravi",
        comment:
          "Arjun explained my Dasha period so well that it felt like puzzle pieces falling into place. His guidance wasn’t vague, it was structured and practical. I finally feel like I understand my timing.",
      },
      {
        name: "Emily",
        comment:
          "No drama, just depth. Arjun walked me through my chart with focus and clarity, and his advice felt rooted in real tradition. He gave me a gemstone suggestion that actually feels right for me.",
      },
    ],
  },
  {
    name: "Claire Bennett",
    photo: advisor8,
    exp: "Life path astrologer · 9 years of practice",
    reviews: "(1124)",
    rating: 4.6,
    assistantId: "asst_YeNtBY0l4bUdJ853uyhpY5z2",
    practiceYears: 9,
    expertise: "Life path astrologer",
    bio: "I’ve always believed that your birth chart is like a cosmic blueprint - and I love helping people decode it. With almost 10 years of practice, I provide practical answers, deeply focused on purpose. Whether you’re lost in love or unsure about your next step in life, I’ll help you align with your natural flow and see the bigger picture your stars are painting.",
    quote:
      "Your birth chart is your personal roadmap. Let’s explore where the stars are guiding you next.",
    message:
      "There’s a reason you’ve felt the pull to ask bigger questions. Let’s explore your Sun, Moon, and Rising signs to reconnect with your direction, timing, and the path that truly fits.",
    categories: [
      "Natal Chart",
      "Life Purpose",
      "Compatibility",
      "Career Path Readings",
      "Energy Channeling",
    ],
    comments: [
      {
        name: "Emily",
        comment:
          "Claire helped me understand the emotional side of my chart, especially around why I keep second-guessing myself. I left our chat feeling more like myself.",
      },
      {
        name: "Andre",
        comment:
          "Straight up, Claire’s insights were next-level. She broke down my purpose and career direction in a way that just made sense. No fluff, just real clarity.",
      },
      {
        name: "Samantha",
        comment:
          "Her reading helped me feel more at peace with where I am in life. She explained my chart so clearly, it felt like she was telling my story back to me. Soft, honest, and exactly what I needed.",
      },
    ],
  },
  {
    name: "Mason Taylor",
    photo: advisor9,
    exp: "Tarot specialist · 11 years of practice",
    reviews: "(1588)",
    rating: 4.8,
    assistantId: "asst_kKiBbRLMJtD29UTlg9c4PIvV",
    practiceYears: 11,
    expertise: "Tarot specialist",
    bio: "My first tarot deck was a gift - and it felt more like a key than a tool. Since then, I’ve spent 11 years helping people unlock doors they didn’t even know were there. I don’t do vague predictions or fortune-cookie advice. I give honest, grounded readings that speak to your right now - because when we understand this moment, the next one becomes a lot clearer.",
    quote: "The cards hold answers you already sense. I'm here to help you hear them more clearly.",
    message:
      "You already know the truth—you just haven’t looked straight at it yet. Through tarot and honest reflection, I’ll help you clear the fog and face what’s been waiting underneath.",
    categories: [
      "Tarot Spreads",
      "Spiritual Path",
      "Relationship Clarity",
      "Shadow Work",
      "Chakras Healing",
    ],
    comments: [
      {
        name: "Lina",
        comment:
          "I’ve done tarot before, but never like this. Mason connected dots I didn’t even know were related. It felt less like a “reading” and more like a moment of truth.",
      },
      {
        name: "Carlos",
        comment:
          "Mason was calm, direct, and on point. His reading helped me make a decision I’d been struggling with for weeks. It was like he pulled the fog off my brain.",
      },
      {
        name: "Jess",
        comment:
          "I felt like Mason was reading my mind. The card he pulled first hit so close to what I was going through, it actually gave me chills. He didn’t sugarcoat, but I felt supported the whole time.",
      },
    ],
  },
  {
    name: "Brooke Hayes",
    photo: advisor10,
    exp: "Love astrologer · 15 years of practice",
    reviews: "(1943)",
    rating: 4.7,
    assistantId: "asst_3MP3VG8orJydCuAAO2KFWlr3",
    practiceYears: 15,
    expertise: "Love astrologer",
    bio: "I've always been fascinated by what brings people together - and what pulls them apart. As a relationship astrologer with 15 years of experience, I help people make sense of emotional patterns, karmic bonds, and soulmate timing. Whether you're heartbroken, deeply in love, or somewhere in between, your chart tells a story of connection. I’m here to help you read it with compassion and clarity.",
    quote:
      "Love doesn’t have to feel like a mystery - the stars hold the keys to connection and clarity.",
    message:
      "Some relationships are chapters. Others are lifetimes. I’ll help you understand who’s meant to stay, who was meant to teach, and what your love energy is truly drawn to next.",
    categories: [
      "Synastry",
      "Breakup Readings",
      "Twin Flame Insights",
      "Timing For Marriage",
      "Emotional Healing",
    ],
    comments: [
      {
        name: "Fatima",
        comment:
          "I was mid-breakup and spiraling when I reached out. Brooke’s reading helped me see the pattern I was stuck in. So grateful for her compassion and clarity.",
      },
      {
        name: "Jayden",
        comment:
          "She’s real. Brooke told me what I needed to hear, not just what I wanted. Her take on timing for love and relationships hit harder than I expected, in the best way.",
      },
      {
        name: "Rachel",
        comment:
          "Brooke helped me understand a relationship I couldn’t make sense of for years. Her insights about our charts felt so personal - it was like she knew what I hadn’t said out loud. I left feeling lighter.",
      },
    ],
    compatibilityMessage:
      "Curious what this means for your real connection? I can look deeper into your chart or theirs and help you understand what’s truly unfolding between you.",
  },
  {
    name: "Lucas Reed",
    photo: advisor11,
    exp: "Numerology guru · 10 years of practice",
    reviews: "(1011)",
    rating: 4.8,
    assistantId: "asst_l8mV5LPaht1z8pRWZw1dHQ2U",
    practiceYears: 10,
    expertise: "Numerology guru",
    bio: "For me, numbers aren’t just digits - they’re energy. They vibrate, speak, and guide. I’ve spent the past decade turning names and birthdays into insight, helping people understand their purpose, challenges, and potential. My style is straight-talking and supportive. If you want to stop guessing and start aligning with your true timing, let’s run the numbers.",
    quote: "Numbers don’t lie. They reveal who you are - and who you’re becoming.",
    message:
      "You’re not here by chance—your birth date holds a plan, a purpose, and a pattern. I’ll help you read it, own it, and use it to shift what’s been stuck.",
    categories: [
      "Destiny Numbers",
      "Year Cycle",
      "Compatibility",
      "Karmic Debt",
      "Mindset Guidance",
    ],
    comments: [
      {
        name: "Maya",
        comment:
          "I didn’t realize how much clarity I needed until Lucas walked me through my Destiny number. It was like he saw the version of me I’ve been trying to become. Felt more empowered than I have in a while.",
      },
      {
        name: "Eric",
        comment:
          "Super practical and low-key inspiring. Lucas helped me understand the timing of some major stuff I’ve been going through. The way he ties numbers to mindset is seriously underrated.",
      },
      {
        name: "Tasha",
        comment:
          "Lucas broke down my numbers in a way that actually made sense. He explained my Life Path and personal year like a roadmap, and it gave me real direction.",
      },
    ],
  },
  {
    name: "Vanessa Cole",
    photo: advisor12,
    exp: "Emotional astrology · 13 years of practice",
    reviews: "(1884)",
    rating: 4.5,
    assistantId: "asst_0kbeNFmCPsSHomd8k4fVU4yn",
    practiceYears: 13,
    expertise: "Emotional astrology",
    bio: "You ever feel like your emotions don’t make sense - even to you? That’s often the Moon talking. I work with lunar cycles, Venus placements, and emotional timing to help people create rituals of self-care that actually fit. I’m not here to fix you - you’re not broken. I’m here to help you feel seen, understood, and aligned with your cosmic rhythm.",
    quote:
      "Your emotions move with the moon - let me show you how to care for your soul through the stars.",
    message:
      "Your Moon sign knows what you feel—even when you’re not sure how to name it. Let’s explore your emotional timing and inner cycles, gently and without pressure.",
    categories: [
      "Moon Sign",
      "Personal Rituals",
      "Lunar Cycles",
      "Planetary Timing",
      "Wellness Charts",
    ],
    comments: [
      {
        name: "Nathan",
        comment:
          "I’ve been emotionally all over the place, and Vanessa helped me connect it to the lunar cycle and my chart. She made me feel understood. The ritual she suggested really helped me reset.",
      },
      {
        name: "Amira",
        comment:
          "Talking to Vanessa was like exhaling after holding my breath for too long. Her insight into my emotional patterns was gentle but deep. I didn’t even know astrology could be this healing.",
      },
      {
        name: "Isabel",
        comment:
          "This reading felt like a hug in the middle of chaos. She helped me understand my Moon sign in a way no one else ever has. I finally feel like I’m allowed to feel how I feel.",
      },
    ],
  },
  {
    name: "Ethan Wallace",
    photo: advisor13,
    exp: "Palm reader · 12 years of practice",
    reviews: "(1399)",
    rating: 4.9,
    assistantId: "asst_aNqmuUgaMFtWL4Spbpjhn1eY",
    practiceYears: 12,
    expertise: "Palm reader",
    bio: "I don’t need your birth chart to understand you - your hands already know. For 12 years, I’ve read palms for people who needed answers about love, purpose, and what comes next. I’m observant, calm, and probably the most practical mystic you’ll meet. If you’re looking for clarity, I’ll help you find it - right in the lines you’ve carried since birth.",
    quote: "Your hands tell a story written long before today. Let’s read what’s still unfolding.",
    message:
      "Your palm holds a living record of your experiences, choices, and turning points. Let’s explore what your Life Line, Heart Line, and fingers are quietly telling us about your path.",
    categories: [
      "Ancient Palmistry",
      "Life Path",
      "Relationship Signs",
      "Career Destiny",
      "Hand Patterns",
    ],
    comments: [
      {
        name: "Leo",
        comment:
          "Ethan didn’t ask leading questions - he just looked at my palm and started saying things that hit way too close to home (in a good way). Super steady, no drama just real insight.",
      },
      {
        name: "Sophie",
        comment:
          "There’s something calming about the way Ethan explains what he sees. He showed me how much potential is in my lines, especially around relationships. Felt like he actually saw me, not just my hand.",
      },
      {
        name: "Rajiv",
        comment:
          "I’ve had palm readings before, but this one was the most detailed and grounded. Ethan pointed out things in my Life Line and fingers that lined up with my biggest life decisions.",
      },
    ],
  },
  {
    name: "Sophie Carter",
    photo: advisor14,
    exp: "Aura healer · 14 years of practice",
    reviews: "(1587)",
    rating: 4.7,
    assistantId: "asst_V6clUNqJIMeM4UGHkMVhrKNf",
    practiceYears: 14,
    expertise: "Aura healer",
    bio: "I can feel your energy before you text a word. That’s not a metaphor - it’s what I’ve done every day for the past 14 years. I help people reconnect with themselves through aura scans, chakra balancing, and emotional energy work. Whether you’re burned out, blocked, or just a little dimmed, we’ll work together to get your light shining again.",
    quote:
      "Your energy speaks volumes. Let’s clear what’s heavy and let your light shine through again.",
    message:
      "If you’ve been feeling off, scattered, or emotionally tired—your field may be asking to return to balance. Let’s explore what your energy is holding and gently guide it back into flow.",
    categories: [
      "Chakra Alignment",
      "Aura Reading",
      "Cleansing",
      "Blockage Clearing",
      "Grounding Techniques",
    ],
    comments: [
      {
        name: "Melina",
        comment:
          "Sophie’s energy is like a deep exhale. I didn’t even realize how heavy I was feeling until she helped me clear it. I left the session feeling calmer, lighter, and more like myself again.",
      },
      {
        name: "Ananya",
        comment:
          "That session was more powerful than I expected. Sophie guided me through a grounding practice that released so much tension. Don’t underestimate her, she’s tuned in.",
      },
      {
        name: "Jordan",
        comment:
          "She tuned in right away and described exactly what I was feeling without me saying a word. Would definitely go back to her when I need to reset.",
      },
    ],
  },
  {
    name: "Dylan Brooks",
    photo: advisor15,
    exp: "Karmic astrologer · 9 years of practice",
    reviews: "(1332)",
    rating: 4.6,
    assistantId: "asst_9AnrXwmKNZGbsdNgxCreEIsG",
    practiceYears: 9,
    expertise: "Karmic astrologer",
    bio: "This isn’t your first life. You’ve been here before - and your birth chart remembers. I work with karmic astrology, ancestral wounds, and soul-level patterns to help you break the cycles that no longer serve you. My sessions aren’t fluffy - they’re real, raw, and sometimes intense. But if you're ready to remember why you're here, I’m ready to show you.",
    quote:
      "You’re not just living this life - you’re continuing a story. I’ll help you understand the chapters you’ve inherited and how to rewrite the ending.",
    message:
      "Some questions don’t begin in this lifetime. Your chart carries the story your soul has lived before—and the patterns it's still healing. Let’s uncover the truth beneath your repetition.",
    categories: [
      "Past Life",
      "Karmic Patterns",
      "Soul Purpose",
      "Ancestral Blocks",
      "Spiritual Growth",
    ],
    comments: [
      {
        name: "Leila",
        comment:
          "I didn’t even know karmic astrology was a thing, but Dylan showed me things in my chart that felt like emotional truth. I left the session with more self-awareness than I’ve had in a long time.",
      },
      {
        name: "Tariq",
        comment:
          "Dylan doesn’t just read your chart, he reads you. He explained a karmic pattern I’ve been stuck in for years, and suddenly it all made sense. His words hit deep, but in the best way.",
      },
      {
        name: "Jonas",
        comment:
          "His take on my South Node and past-life themes explained a lot of emotional baggage I didn’t have language for. Heavy but healing.",
      },
    ],
  },
]
